module.exports = __webpack_public_path__ + "df3c6895b5710fa5f798ff9de7abbbf8.svg";